import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCalendarClassicRoute: InvariantJiraRoute = {
	name: 'software-calendar-classic',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/:itemId?',
	query: ['date?'],
};
